import clsx from "clsx";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import {
  LogoSVGEmbed,
  NavBar,
  NavBarMobile,
  NavBarSection,
  useDrawer,
} from "@transfr-inc/dashboard-components";
import { useScreenBreakpoint } from "@transfr-inc/dashboard-components/hooks";

import { useRole } from "@queries/account-selectors";
import { Role } from "@models/role";
import { NavbarItemProfile } from "./navbar-item.profile";
import { NavbarRoutes } from "./navbar.routes";
import { useAppStore } from "@src/stores/zustand/app-store";

import "./navbar.scss";

export function NavigationBar({ addNotification, onSkipNavigation }) {
  const location = useLocation();
  const role = useRole();
  const { isMobile } = useScreenBreakpoint();
  const navbarDrawer = useDrawer();
  const navItemsMode = isMobile ? "more" : "full";

  const previewClassroomId = useAppStore((state) => state.previewClassroomId);

  useEffect(() => {
    if (isMobile && navbarDrawer.isExpanded) {
      navbarDrawer.toggleDrawer();
    }
  }, [location, isMobile]);

  const drawerContent = (
    <>
      <div className="skip-nav">
        <a href="#" onClick={(e) => onSkipNavigation(e)}>
          Skip Navigation
        </a>
      </div>
      <div>
        <LogoSVGEmbed onlyLogo={!navbarDrawer.isExpanded} />
      </div>
      <div
        className={clsx(
          "items-container",
          !navbarDrawer.isExpanded && !isMobile && "collapsed"
        )}
      >
        <NavbarRoutes
          addNotification={addNotification}
          isExpanded={isMobile ? true : navbarDrawer.isExpanded}
          mode={navItemsMode}
        ></NavbarRoutes>
      </div>
      <NavbarItemProfile
        isExpanded={isMobile ? true : navbarDrawer.isExpanded}
      ></NavbarItemProfile>
    </>
  );

  return !isMobile ? (
    <NavBar
      className={clsx(
        "unified-dashboard-navbar",
        previewClassroomId && "hidden"
      )}
      onSkipNavigation={onSkipNavigation}
      drawerConfig={{
        collapsedSize: "90px + 2rem",
      }}
    >
      <NavBarSection>
        <NavbarRoutes
          addNotification={addNotification}
          isExpanded={isMobile ? true : navbarDrawer.isExpanded}
          mode={navItemsMode}
        />
      </NavBarSection>
      <NavBarSection className="bottom-section">
        <NavbarItemProfile
          isExpanded={isMobile ? true : navbarDrawer.isExpanded}
        />
      </NavBarSection>
    </NavBar>
  ) : (
    <NavBarMobile
      drawerContent={drawerContent}
      moreIcon="circle-user"
      useMore={role != Role.STUDENT.id}
      isDrawerExpanded={navbarDrawer.isExpanded}
      onDrawerTransitionEnd={navbarDrawer.onTransitionEnd}
      onMoreClick={navbarDrawer.toggleDrawer}
    >
      <NavbarRoutes addNotification={addNotification} mode="mobile" />
      {role == Role.STUDENT.id && (
        <NavbarItemProfile className={"hide-more"}></NavbarItemProfile>
      )}
    </NavBarMobile>
  );
}
